<!--
 * @Date: 2023-12-28 16:30:17
 * @Author: jm
 * @LastEditTime: 2024-03-12 16:47:15
 * @LastEditors: jm
 * @FilePath: \miniclub\src\App.vue
 * @Description: 
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted() {
    const playedList = JSON.parse(localStorage.getItem("h5miniclub"));
    if (playedList) {
      if (playedList[0].expires && Date.now() > playedList[0].expires) {
        localStorage.removeItem("h5miniclub");
      }
    }
  },
};
</script>
